import { customerApi } from "../../utils/apiConfig";

export const createKantarCapture = (data, token) =>
  customerApi.post("/sevkiyat/kantar-capture", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const addGeneralLoadingSnapshot = (data, token) =>
  customerApi.post("/sevkiyat/add-general-loading-snapshot", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const getPendingKantarCaptureList = (params = {}, token) =>
  customerApi.get("/sevkiyat/pending", {
    params,
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const getShipmentCameraControlDetail = (id) =>
  customerApi.get(`/sevkiyat/detail/${encodeURIComponent(id)}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });

export const getShipmentCameraControlList = (params = {}, token) =>
  customerApi.get("/sevkiyat/list", {
    params,
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const createLoadingControl = (data, token) =>
  customerApi.post("/sevkiyat/create-loading-control", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const saveLoadingControlForm = (data, token) =>
  customerApi.post("/sevkiyat/save-loading-form", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const addLoadingSnapshot = (data, token) =>
  customerApi.post("/sevkiyat/add-loading-snapshot", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const completeLoadingControl = (data, token) =>
  customerApi.post("/sevkiyat/complete-loading-control", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const addManualLoadingPhotos = ({
  id,
  files = [],
  visualKey = "",
  note = "",
}) => {
  const formData = new FormData();

  formData.append("id", id);

  if (visualKey) {
    formData.append("visualKey", visualKey);
  }

  if (note) {
    formData.append("note", note);
  }

  files.forEach((file) => {
    formData.append("photos", file);
  });

  return customerApi.post("/shipment-camera-control/manual-photos", formData, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteLoadingControl = (data) =>
  customerApi.post("/sevkiyat/delete-loading-control", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const deleteShipmentCameraPhoto = (data) =>
  customerApi.post("/sevkiyat/delete-photo", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const requestLiveCameraAccessCode = () =>
  customerApi.post(
    "/sevkiyat/live-camera/request-code",
    {},
    {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      withCredentials: true,
    }
  );

export const unlockLiveCameras = (code) =>
  customerApi.post(
    "/sevkiyat/live-camera/unlock",
    { code },
    {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      withCredentials: true,
    }
  );

export const getLiveCameraAccessStatus = () =>
  customerApi.get("/sevkiyat/live-camera/status", {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    withCredentials: true,
  });

export const lockLiveCameras = () =>
  customerApi.post(
    "/sevkiyat/live-camera/lock",
    {},
    {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      withCredentials: true,
    }
  );

export const getLiveCameraStreamUrl = (cameraKey) =>
  customerApi.getUri({
    url: `/sevkiyat/live-camera/${encodeURIComponent(cameraKey)}`,
  });
